{
  "metadata": {
    "id": "rosepine-light",
    "name": "Rose Pine",
    "description": "Портировано из темы «Rose Pine» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "rosepine.json",
      "project": "rose-pine",
      "url": "https://github.com/rose-pine/rose-pine-theme",
      "upstreamFile": "packages/ui/src/theme/themes/rosepine.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.8,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.426,
      "paletteMaxS": 0.522,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.1,
      "syntaxVsTextMinDeltaE": 6.2,
      "chartsMinDeltaE": 25.5,
      "textSeparationDeltaE": 10.8,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "operator",
          "deltaE": 13.5
        },
        {
          "a": "number",
          "b": "operator",
          "deltaE": 12.4
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#31748f",
      "hover": "#2c6881",
      "active": "#285f75",
      "foreground": "#ffffff",
      "muted": "#31748f80",
      "emphasis": "#31748f"
    },
    "surface": {
      "background": "#faf4ed",
      "foreground": "#494565",
      "muted": "#cfcad0",
      "mutedForeground": "#4a4655",
      "elevated": "#bab5c1",
      "elevatedForeground": "#484464",
      "raised": "#a09cb0",
      "raisedForeground": "#36334b",
      "overlay": "#faf4ed33",
      "subtle": "#e5dfdf"
    },
    "interactive": {
      "border": "#9692a8",
      "borderHover": "#c7c2c8",
      "borderFocus": "#31748f",
      "selection": "#57527924",
      "selectionForeground": "#575279",
      "focus": "#31748f59",
      "focusRing": "#31748f47",
      "cursor": "#575279",
      "hover": "#57527917",
      "active": "#57527924"
    },
    "status": {
      "error": "#ab526c",
      "errorForeground": "#ffffff",
      "errorBackground": "#ab526c1a",
      "errorBorder": "#ab526c59",
      "warning": "#9e6210",
      "warningForeground": "#ffffff",
      "warningBackground": "#9e62101a",
      "warningBorder": "#9e621059",
      "success": "#286983",
      "successForeground": "#ffffff",
      "successBackground": "#2869831a",
      "successBorder": "#28698359",
      "info": "#467881",
      "infoForeground": "#ffffff",
      "infoBackground": "#4678811a",
      "infoBorder": "#46788159"
    },
    "pr": {
      "open": "#286983",
      "draft": "#585464",
      "blocked": "#9e6210",
      "merged": "#d16f6b",
      "closed": "#ab526c"
    },
    "syntax": {
      "base": {
        "background": "#cfcad0",
        "foreground": "#575279",
        "comment": "#504b5a",
        "keyword": "#235c73",
        "string": "#794b0c",
        "number": "#624e79",
        "function": "#97342f",
        "variable": "#575279",
        "type": "#265954",
        "operator": "#555269"
      },
      "tokens": {
        "commentDoc": "#504b5a",
        "stringEscape": "#555269",
        "keywordImport": "#235c73",
        "storageModifier": "#235c73",
        "functionCall": "#97342f",
        "method": "#97342f",
        "variableProperty": "#97342f",
        "variableOther": "#575279",
        "variableGlobal": "#624e79",
        "variableLocal": "#555269",
        "parameter": "#575279",
        "constant": "#624e79",
        "class": "#265954",
        "className": "#265954",
        "interface": "#265954",
        "struct": "#265954",
        "enum": "#265954",
        "typeParameter": "#265954",
        "namespace": "#265954",
        "module": "#235c73",
        "tag": "#235c73",
        "jsxTag": "#235c73",
        "tagAttribute": "#97342f",
        "tagAttributeValue": "#794b0c",
        "boolean": "#624e79",
        "decorator": "#235c73",
        "label": "#97342f",
        "regexp": "#794b0c"
      }
    },
    "charts": {
      "series": [
        "#31748f",
        "#293b4c",
        "#284b83",
        "#9e6210",
        "#ab526c"
      ]
    },
    "chat": {
      "background": "#faf4ed",
      "userMessage": "#484464",
      "userMessageBackground": "#bab5c1",
      "assistantMessage": "#575279",
      "assistantMessageBackground": "#cfcad0",
      "timestamp": "#585464",
      "divider": "#9692a8",
      "typing": "#585464"
    },
    "loading": {
      "spinner": "#31748f",
      "spinnerTrack": "#cfcad0",
      "skeleton": "#cfcad0",
      "shimmer": "#c8c3cb"
    },
    "tools": {
      "background": "#cfcad0",
      "border": "#9692a8",
      "headerHover": "#c9c4cc",
      "icon": "#31748f",
      "title": "#575279",
      "description": "#585464",
      "edit": {
        "added": "#286983",
        "addedBackground": "#2869831a",
        "removed": "#ab526c",
        "removedBackground": "#ab526c1a",
        "modified": "#467881",
        "modifiedBackground": "#4678811a",
        "lineNumber": "#585464"
      }
    },
    "markdown": {
      "heading1": "#575279",
      "heading2": "#575279",
      "heading3": "#575279",
      "heading4": "#575279",
      "link": "#31748f",
      "linkHover": "#2c6881",
      "inlineCode": "#794b0c",
      "inlineCodeBackground": "#cfcad0",
      "blockquote": "#585464",
      "blockquoteBorder": "#9692a8",
      "listMarker": "#31748fbf",
      "bold": "#575279",
      "italic": "#575279e6",
      "strikethrough": "#585464",
      "hr": "#9692a8"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#823f44",
        "foreground": "#ffffff",
        "contrast": 7.65
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c67756",
        "foreground": "#000000",
        "contrast": 6.17
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c0a764",
        "foreground": "#000000",
        "contrast": 8.95
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bcce63",
        "foreground": "#000000",
        "contrast": 12.15
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#718e42",
        "foreground": "#000000",
        "contrast": 5.65
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#62cb5f",
        "foreground": "#000000",
        "contrast": 10.23
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#66c188",
        "foreground": "#000000",
        "contrast": 9.55
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#46876f",
        "foreground": "#000000",
        "contrast": 4.96
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#64ccc2",
        "foreground": "#000000",
        "contrast": 10.96
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#437585",
        "foreground": "#ffffff",
        "contrast": 5.09
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5b81ba",
        "foreground": "#000000",
        "contrast": 5.29
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3a3c7f",
        "foreground": "#ffffff",
        "contrast": 9.85
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#7352c1",
        "foreground": "#ffffff",
        "contrast": 5.67
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c659c4",
        "foreground": "#000000",
        "contrast": 5.63
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#834077",
        "foreground": "#ffffff",
        "contrast": 7.08
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c5567e",
        "foreground": "#000000",
        "contrast": 5.01
      }
    ]
  }
}
